export default "<div class=\"analysis-activity-content\">\n<div>\n    {{data.error}}\n</div>\n</div>";